module.exports = __webpack_public_path__ + "img/clean_precheck_3.076998e0.svg";